import { waitElementPresence } from '../../utils/jsHelpers'

export function nonSponsoredListingsPath (location) {
  const pathname = location.pathname
  const searchParams = new URLSearchParams(location.search)

  return pathname.includes('/sellers') || searchParams.has('similar_query') || searchParams.has('sourcing_objective') || searchParams.has('trade_project')
}

export function sponsoredListingsQuery (searchHelper) {
  const queryObject = searchHelper.getQuery()
  queryObject.analytics = false
  queryObject.clickAnalytics = false
  queryObject.getRankingInfo = false
  queryObject.userToken = null
  queryObject.hitsPerPage = 4
  queryObject.removeWordsIfNoResults = 'none'

  return queryObject
}

export function setSponsoredListingsOnPage (hits) {
  const div = document.createElement('div')
  div.setAttribute('class', 'vjs-sponsored-listings-hits')
  div.innerHTML = JSON.stringify(hits)
  const wrapper = document.querySelector('[data-id="content-sponsored-listings"]')
  wrapper.appendChild(div)
}

export function clearSponsoredListingsFromPage () {
  const wrapper = document.querySelector('[data-id="content-sponsored-listings"]')
  wrapper?.querySelector('.vjs-sponsored-listings-hits')?.remove()
}

export function mergeSponsoredListings (hits, sponsoredHits) {
  const existingIDs = new Set(hits.map(item => item.objectID))
  const mergedHits = [...hits]

  sponsoredHits.forEach(item => {
    if (!existingIDs.has(item.objectID)) {
      mergedHits.push(item)
      existingIDs.add(item.objectID)
    }
  })

  return mergedHits
}

export function waitSponsoredListings () {
  return new Promise((resolve, reject) => {
    const wrapper = document.querySelector('[data-id="content-sponsored-listings"]')
    waitElementPresence(wrapper, '.vjs-sponsored-listings-hits').then((element) => {
      const sponsoredListingsHits = (element !== null) ? JSON.parse(element.innerHTML) : []
      resolve(sponsoredListingsHits)
    })
  })
}

export function shouldShowSponsoredListingsInMainResults () {
  const sponsoredHitsOnPageStore = document.querySelector('.vjs-sponsored-listings-hits')
  if (!sponsoredHitsOnPageStore) return

  const sponsoredHits = JSON.parse(sponsoredHitsOnPageStore?.textContent)
  const inProductTile2025Redesign = document.getElementById('vjs-product-tile-2025-redesign')

  return inProductTile2025Redesign && JSON.parse(inProductTile2025Redesign?.value) && sponsoredHits && sponsoredHits.length > 0
}
